var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08301 9.50016H17.9163M2.08301 5.54183H6.04134M13.958 5.54183H17.9163M2.08301 13.4585H6.04134M13.958 13.4585H17.9163M6.04134 17.4168V1.5835M13.958 17.4168V1.5835M5.88301 17.4168H14.1163C15.4465 17.4168 16.1115 17.4168 16.6196 17.158C17.0665 16.9303 17.4298 16.5669 17.6575 16.1201C17.9163 15.612 17.9163 14.947 17.9163 13.6168V5.3835C17.9163 4.05337 17.9163 3.38831 17.6575 2.88027C17.4298 2.43338 17.0665 2.07005 16.6196 1.84236C16.1115 1.5835 15.4465 1.5835 14.1163 1.5835H5.88301C4.55288 1.5835 3.88782 1.5835 3.37978 1.84236C2.9329 2.07005 2.56957 2.43338 2.34187 2.88027C2.08301 3.38831 2.08301 4.05337 2.08301 5.3835V13.6168C2.08301 14.947 2.08301 15.612 2.34187 16.1201C2.56957 16.5669 2.9329 16.9303 3.37978 17.158C3.88782 17.4168 4.55288 17.4168 5.88301 17.4168Z",
    stroke: "#475467",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilmIcon);
export default __webpack_public_path__ + "static/media/film-icon.134f85d541ac18e3b772184676ad0d82.svg";
export { ForwardRef as ReactComponent };